function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-21c11e58\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!../../../node_modules/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./ImpactProjectHeader.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!../../../node_modules/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./ImpactProjectHeader.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-21c11e58\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!../../../node_modules/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./ImpactProjectHeader.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21c11e58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/impact-project/ImpactProjectHeader.vue
// module id = 280
// module chunks = 0